import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { format as formatDate } from 'date-fns';

import { OfficeServerDetails } from '../../../domain/repositories/ConfigRepository';

const Container = styled.div`
  width: 380px;
`;

const EntryContainer = styled.div`
  margin-bottom: 25px;
  
  & > label {
    display: block;
    font-size: 1.4rem;
    font-weight: bold;
    margin-bottom: 5px;
  }

  & > p {

  }
`;

interface StatusBadgeProps {
  active: boolean;
}

const StatusBadge = styled.div<StatusBadgeProps>`
  display: inline-block;
  background-color: #0d9bda;
  color: #ffffff;
  padding: 7px 15px;
  box-sizing: border-box;
  border-radius: 3px;

  ${({active}) => !active && css`
    background-color: #e9e9e9;
    color: #7e7e7e;
  `}
`;

interface Props {
  serverDetails?: OfficeServerDetails;
}

export default function DetailsModalContent(props: Props) {
  const { serverDetails } = props;

  if (!serverDetails) return null;

  const {
    officeServer,
    serverStatus,
    createdBy,
    createdOn,
    lastModifiedBy,
    lastModifiedOn
  } = serverDetails;

  const createdOnDateObj = new Date(createdOn);
  const createdOnDateString = formatDate(createdOnDateObj, 'dd-MM-yyyy');
  const createdOnTimeString = formatDate(createdOnDateObj, 'hh:mm aa');

  const lastModifiedOnDateObj = new Date(lastModifiedOn);
  const lastModifiedOnDateString = formatDate(lastModifiedOnDateObj, 'dd-MM-yyyy');
  const lastModifiedOnTimeString = formatDate(lastModifiedOnDateObj, 'hh:mm aa');

  return (
    <Container>
      <EntryContainer>
        <label>Server</label>
        <p>{officeServer}</p>
      </EntryContainer>

      <EntryContainer>
        <label>Status</label>

        <StatusBadge active={serverStatus}>
          {serverStatus ? 'Active' : 'Inactive'}
        </StatusBadge>
      </EntryContainer>

      <EntryContainer>
        <label>Created On</label>
        <div>
          <p>{createdOnDateString}</p>
          <p>{createdOnTimeString}</p>
        </div>
      </EntryContainer>

      <EntryContainer>
        <label>Created By</label>
        <p>{createdBy}</p>
      </EntryContainer>

      <EntryContainer>
        <label>Last Modified On</label>
        <div>
          <p>{lastModifiedOnDateString}</p>
          <p>{lastModifiedOnTimeString}</p>
        </div>
      </EntryContainer>

      <EntryContainer>
        <label>Last Modified By</label>
        <p>{lastModifiedBy}</p>
      </EntryContainer>

    </Container>
  );
}